// Czech

const lang = {
  gateMediaPreviewHeader: 'Může se vám líbit také',
  loadmore: 'Ukázat víc',
  nextMedia: 'Další média',
  previousMedia: 'Předchozí média',
  closePost: 'Zavřít příspěvek',
  nextPost: 'Další příspěvek',
  previousPost: 'Předchozí příspěvek',
  outOfStock: 'Vyprodáno',
  numberOfReviews(n) {
    return n >= 1 && n < 5 ? 'recenze' : 'recenzí'
  },
  reportFormField: 'Vložte vzkaz, prosím',
  reportPost: 'Nahlásit příspěvek',
  reportFormTitle: 'Chcete tento snímek nahlásit?',
  reportFormDetails:
    'Pokud se domníváte, že tento snímek je nevhodný, nezákonný nebo porušuje osobní práva, můžete nahlásit obsah. Pokud snímek/text nahlásíte, budou informováni moderátoři posuzující obsah a budou podniknuty náležité kroky.',
  reportFormMessagePlaceholder: 'Uveďte důvod nahlášení',
  reportFormMessageLabel: 'Zpráva',
  reportFormEmailLabel: 'Váš e‑mail',
  reportFormSubmitButtonText: 'Odeslat zprávu',
  reportFormCancelButtonText: 'Zrušit',
  reportFormSentTitle: 'Děkujeme za vaši zprávu!',
  reportFormSentCloseButtonText: 'Zavřít',
  cardAndTileAriaLabel: 'Níže je uveden seznam příspěvků z účtů na různých sociálních médiích',
  carouselAriaLabel: 'Níže je uveden karusel s příspěvky z účtů na různých sociálních médiích',
  singleAriaLabel: 'Níže je příspěvek z účtu na sociálních sítích',
  poweredBy: 'Poskytuje Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publikovaná dne ${date}` : ''
    const createdByString = userName ? ` od ${userName}` : ''
    return `Fotografie${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Nahrajte svá média',
  openTheGate: 'Otevřete dialog',
}

export default lang
